// トップスライダーの起動 // Launch the top slider

const loopSwiper = new Swiper(".p-loopSlider", {
  speed: 5000, // スライド変化時間
  loop: true,
  loopAdditionalSlides: 1,
  slidesPerView: 'auto',
  spaceBetween: 20,
  autoplay: {
    delay: 0, //　スライダー表示時間
  },
});

document.addEventListener('DOMContentLoaded', () => {
  const wrap  = document.querySelector('.js-fv-anim');
  if (!wrap) return; // ないページでは何もしない

  const cover = wrap.querySelector('.cover');
  const text  = wrap.querySelector('h2');
  const text2 = wrap.querySelector('p');
  const fvBg  = document.querySelector('.js-fv-bg');

  // ---- helpers ----------------------------------------------------
  const sleep = (ms) => new Promise(r => setTimeout(r, ms));
  const nextFrame = () => new Promise(r => requestAnimationFrame(r));
  const onTransitionEndOnce = (el, prop = 'transform') =>
    new Promise((resolve) => {
      const handler = (e) => {
        if (!prop || e.propertyName === prop) {
          el.removeEventListener('transitionend', handler);
          resolve();
        }
      };
      el.addEventListener('transitionend', handler);
  });

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- 初期化（チラつき防止のためトランジション無効で状態確定） ----
  wrap.style.opacity = '1';
  cover.style.transition = 'none';
  cover.style.transformOrigin = 'left';
  cover.style.transform = 'scaleX(0)';
  if (text)  text.style.visibility = 'hidden';
  if (text2) text2.style.visibility = 'hidden';

  // reduced-motion の場合は即時最終状態へ
  if (prefersReduced) {
    cover.style.transformOrigin = 'right';
    cover.style.transform = 'scaleX(0)';
    if (fvBg) fvBg.classList.add('is-show');
    document.body.classList.add('anim-end');
    return;
  }

  (async () => {
    // レイアウト確定
    void cover.getBoundingClientRect();

    // 1段目：左→右に伸びる（InExpo風）
    cover.style.transition = 'transform 400ms cubic-bezier(0.95, 0.05, 0.795, 0.035)';
    await nextFrame(); // 同フレーム適用回避
    cover.style.transform = 'scaleX(1)';
    await onTransitionEndOnce(cover, 'transform');

    // 2段目準備：右基点に変更＆テキスト表示
    cover.style.transformOrigin = 'right';
    if (text)  text.style.visibility = 'visible';
    if (text2) text2.style.visibility = 'visible';
    void cover.getBoundingClientRect();

    // 2段目：右→左に消える（OutExpo風）
    cover.style.transition = 'transform 400ms cubic-bezier(0.19, 1, 0.22, 1)';
    await nextFrame();
    cover.style.transform = 'scaleX(0)';
    await onTransitionEndOnce(cover, 'transform');

    // ✔ js-fv-anim 完了
    fvBg.classList.add('is-show');
    await sleep(600) //この後header
    document.body.querySelector('#container').classList.add('anim-end');
    await sleep(400) //この後header
  })();
});